import { ReactNode } from 'react';
import styled from 'styled-components';
import { rgba } from 'polished';

import { c14142E, c1D1D37, cFFFFFF } from '#/colors';

interface Props {
  readonly children: ReactNode;
  readonly label: ReactNode;
  readonly labelId: string;
  readonly mode?: 'normal' | 'compact';
}

export default function Field(props: Props) {
  const { children, label, labelId, mode = 'normal' } = props;

  switch (mode) {
    case 'normal':
      return (
        <Container>
          <Label htmlFor={labelId}>{label}</Label>
          <Content>{children}</Content>
        </Container>
      );
    case 'compact':
      return (
        <ContainerCompact>
          <Label htmlFor={labelId}>{label}</Label>
          <ContentCompact>{children}</ContentCompact>
        </ContainerCompact>
      );
    // no default
  }
}

const Container = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  position: relative;
`;

const ContainerCompact = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: row;
  align-items: center;
  position: relative;
`;

const Label = styled.label`
  color: ${rgba(cFFFFFF, 0.7)};
  text-transform: capitalize;
  font-size: 12px;
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 12px;
  background-color: ${c14142E};
  border: 1px solid ${c1D1D37};
  border-radius: 5px;

  &:focus-within {
    background-color: ${c1D1D37};
    input[type='text'] {
      outline: none;
    }
  }
`;

const ContentCompact = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  align-items: center;
`;
